// extracted by mini-css-extract-plugin
export default {"formFieldSearch":"FormSelect_formFieldSearch__w9LhY","loading":"FormSelect_loading__reXkZ","rotation":"FormSelect_rotation__P1--o"};